/** Admin staff/attendants list for one owner (owner-twin). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../src/context/OwnerScopeContext';
import StaffScreen from '../../../../owner/staff/index';

export default function AdminOwnerStaffScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <StaffScreen />
    </OwnerScopeProvider>
  );
}
